import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolsWrenchBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Bold",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "tools-wench" }), /* @__PURE__ */ _jsx("path", { d: "M23.317,4.484a1,1,0,0,0-.738-.657.986.986,0,0,0-.937.28L17.811,8.072a.249.249,0,0,1-.211.074l-1.55-.194a.249.249,0,0,1-.216-.208L15.586,6.2a.255.255,0,0,1,.067-.214l3.832-3.963a.994.994,0,0,0,.249-.946,1,1,0,0,0-.683-.715,6.505,6.505,0,0,0-7.915,8.666.24.24,0,0,1-.049.26l-10,10.332a2.579,2.579,0,0,0-.291,3.3,2.523,2.523,0,0,0,3.811.254s8.944-9.262,10.05-10.431a.235.235,0,0,1,.258-.055,6.505,6.505,0,0,0,8.4-8.2ZM3.876,21.77a1,1,0,1,1-.024-1.414A1,1,0,0,1,3.876,21.77Z" })]
});
export default SvgToolsWrenchBold;
